import { Injectable } from '@angular/core';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  of,
} from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  EventGetModel,
EventAddModel
} from '../interfaces/interfaces';
import { BACKEND_URL } from '../helpers/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as S3 from 'aws-sdk/clients/s3';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class EventDataService {
  private eventsListSubject = new BehaviorSubject<EventGetModel[]>([]);

  private GET_EVENTS = `${BACKEND_URL}/events/getEvents`;
  private DELETE_EVENT = `${BACKEND_URL}/events/deleteEvent`;
  private ADD_EVENT = `${BACKEND_URL}/events/addEvent`;
  private UPDATE_EVENT = `${BACKEND_URL}/events/updateEvent`;
  private UPDATE_EVENT_IMAGES = `${BACKEND_URL}/events/updateEventImages`;

  constructor(private http: HttpClient) { }

  getAllEventsData(): Observable<EventGetModel[]> {
    return this.http
      .get(this.GET_EVENTS)
      .pipe(map((r: any) => Object.values(r['result'])));
  }

  async uploadEventImageData(files: any): Promise<any[]> {
    let promises = [];
    for (let file of files) {
      promises.push(new Promise((resolve, reject) => {
        const bucket = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
        const key = moment().valueOf() + '-' + 'event';
        const params = {
          Bucket: 'stotrasagar-images',
          Key: key,
          Body: file,
          ACL: 'public-read',
          ContentType: file.type,
        };

        bucket.upload(params, async (err: any, data: any) => {
          if (err == null) {
            resolve(data.Location)
          } else {
            reject(err)
          }
        });
      })
      )

    }

    return Promise.all(promises)

  }

  addEventData(addEvent: EventAddModel) {
    try {
      return this.http.post(this.ADD_EVENT, addEvent).toPromise()
    } catch (err) {
      return err as any
    }
  }

  async deleteEventData(eventId: string, keys: string[]) {

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
       eventId: eventId
      },
    };
    
    for (let key of keys) {
      await this.deleteEventImage(key);
    }
    return this.http.delete(this.DELETE_EVENT, options).toPromise();
  }

  async deleteEventImage(link: string) {
    return new Promise((resolve, reject) => {
      const key = link.split('/')[3];
      const s3 = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-images',
        Key: key,
      };

      return s3.deleteObject(params, function (err, data) {
        if (data != null) {
          return resolve("success")
        } else {
          return reject("error")
        }
      });
    });
  }

  async updateEventImageData(eventId: string, links: string[]) {
    return this.http.put(this.UPDATE_EVENT_IMAGES, { imageUrls: links, _id: eventId }).toPromise();
  }

  async deleteEventImageAndUpdate(eventId: string, link: string, links: string[]) {
    const key = link.split('/')[3];
    return new Promise((resolve, reject) => {
      const s3 = new S3(environment.IMAGE_BUCKET_CREDENTIALS);
      const params = {
        Bucket: 'stotrasagar-images',
        Key: key,
      };

      return s3.deleteObject(params, function (err, data) {
        if (data != null) {
          return resolve("success")
        } else {
          return reject("error")
        }
      });
    });

  }

  async updateEventData(event: EventGetModel) {
    try {
      return this.http.put(this.UPDATE_EVENT, event).toPromise();
    } catch (err) {
      return err as any
    }
  }


}
